export default "__VITE_ASSET__B8uZEU0S__"